import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { ProductTagsState } from '../types'

export const isNeedToFetchListSelector = createSelector<ReduxState, ProductTagsState, boolean>(
  featureStateSelector,
  state => {
    const { currentPage, pages } = state.pagination
    return !pages[currentPage]
  }
)

export default isNeedToFetchListSelector
